export default __webpack_public_path__ + "static/media/loader-button-light.f1bc1b2c.svg";